import styled from 'styled-components'

export interface IContainerCard {
  height?: string
}
export const ContainerCard = styled.div<IContainerCard>`
  width: 100%;
  height: ${({ height }) => height};
  overflow: auto;
`
